import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthStateProvider } from '@prlw/core/auth/auth-state.provider';
import { map, switchMap } from 'rxjs/operators';
import { UserDataService } from '@prlw/core/customers/oidc/user-data.service';

const REDIRECT_TO = '/unauthorized';

@Injectable({
  providedIn: 'root',
})
export class DemoOrAboveGuard {
  constructor(
    private readonly authStateProvider: AuthStateProvider,
    private readonly userDataService: UserDataService,
    private readonly router: Router,
  ) {}

  public canActivate(): Observable<true | UrlTree> {
    return this.authStateProvider.authLevel$.pipe(
      switchMap((level) => {
        if (!level.isDemoOrAbove) {
          return of(this.router.parseUrl(REDIRECT_TO));
        }
        return this.userDataService.userData$.pipe(
          map((userData) => {
            const roles = userData?.roles ?? [];
            if (!roles.includes('admin') && !roles.includes('trader')) {
              return this.router.parseUrl(REDIRECT_TO);
            }
            return true;
          }),
        );
      }),
    );
  }
}
